import { createContext, useContext, useState, ReactNode } from 'react';

interface CsvActions {
  uploadLabel?: string;
  onUpload?: () => void;
  downloadUrl?: string;
  downloadLabel?: string;
  secondaryDownloadUrl?: string;
  secondaryDownloadLabel?: string;
  uploading?: boolean;
}

interface CsvActionsContextType {
  csvActions: CsvActions | null;
  setCsvActions: (actions: CsvActions | null) => void;
}

const CsvActionsContext = createContext<CsvActionsContextType>({
  csvActions: null,
  setCsvActions: () => {},
});

export function CsvActionsProvider({ children }: { children: ReactNode }) {
  const [csvActions, setCsvActions] = useState<CsvActions | null>(null);
  return (
    <CsvActionsContext.Provider value={{ csvActions, setCsvActions }}>
      {children}
    </CsvActionsContext.Provider>
  );
}

export function useCsvActions() {
  return useContext(CsvActionsContext);
}
